(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('EodbPublicDashboardController', EodbPublicDashboardController);

    EodbPublicDashboardController.$inject = ['$scope','$filter', 'Principal', '$state', 'EodbPublicDashboardByElastic', 'District', 'EodbPublicDashboardByFilter'];

    function EodbPublicDashboardController ($scope, $filter, Principal, $state, EodbPublicDashboardByElastic, District, EodbPublicDashboardByFilter) {
        var vm = this;

        // SLA Status indicator bands: green >= 90%, yellow 75-89%, red < 75%.
        var SLA_GREEN_FROM = 90;
        var SLA_YELLOW_FROM = 75;

        // The Met/Unmet filter follows the same line as the green band, so "Met" is exactly the
        // set of services showing green and "Unmet" is everything measurable below it.
        var SLA_MET_THRESHOLD = SLA_GREEN_FROM;

        vm.account = null;
        vm.districts = [];
        vm.departments = [];
        vm.services = [];

        // Everything the loaded rows can answer on their own is filtered here in the browser -
        // department, service, SLA status and application status all apply instantly.
        vm.clientFilter = {};

        // District is the exception. A row is one service totalled over every district and carries
        // no district of its own, so the district has to go back to the server, which recomputes
        // all the counts for that district. Level rides along on the same call.
        vm.filter = {};
        vm.hideClear = false;

        // True while a dashboard request is in flight. Every filter control is disabled against
        // this, so nothing can be changed against data that is about to be replaced.
        vm.loading = false;

        // What the District column shows. Deliberately NOT vm.filter.district: that is the live
        // ng-model of the dropdown, so binding the column to it made the column change the moment
        // a district was picked, before the request had even been sent. This is only assigned once
        // a response has come back, so the column always describes the data on screen.
        vm.appliedDistrict = null;
        // The Application Status the rows on screen were actually built for. Held separately from
        // vm.filter for the same reason appliedDistrict is: the dropdown can be changed again
        // while a call is in flight, and the row hiding must describe the rows that came back.
        vm.appliedApplicationStatus = null;
        $scope.CurrentDate = new Date();

        // Time Period column. With no period picked, the rows this dashboard reads are built with
        // the 01-April-2018 window (see /api/updateNewDashboardDataFromStats), so the period runs
        // from that date up to the current month.
        vm.dataStartDate = new Date(2018, 3, 1);
        var DEFAULT_TIME_PERIOD = $filter('date')(vm.dataStartDate, 'MMM yyyy') + ' - ' + $filter('date')($scope.CurrentDate, 'MMM yyyy');
        vm.timePeriod = DEFAULT_TIME_PERIOD;

        // Time Period pickers. Neither end may be in the future, and To cannot precede From.
        vm.datePickerOpenStatus = {};
        vm.dateOptionsFrom = { maxDate: $scope.CurrentDate };
        vm.dateOptionsTo = { maxDate: $scope.CurrentDate };

        vm.openCalendar = function (which) {
            vm.datePickerOpenStatus[which] = true;
        };

        function syncToDateBounds() {
            vm.dateOptionsTo = { minDate: vm.filter.fromDate, maxDate: $scope.CurrentDate };
            // A To already earlier than the new From would be left showing an impossible period.
            if (vm.filter.toDate && vm.filter.fromDate && vm.filter.toDate < vm.filter.fromDate) {
                vm.filter.toDate = null;
            }
        }

        // Hand picking either end means the period is no longer whichever financial year was
        // chosen, so the selector drops back to Custom rather than claiming a year it no longer
        // describes.
        vm.onFromDateChange = function () {
            vm.selectedFinancialYear = null;
            syncToDateBounds();
        };

        vm.onToDateChange = function () {
            vm.selectedFinancialYear = null;
        };

        // ---------------------------------------------------------------------------------
        // Financial year selector. The Indian financial year runs 1 April to 31 March, so
        // FY 2024-25 means 01-04-2024 through 31-03-2025. Picking one just fills the two date
        // fields - it is a shortcut for the calendars, not a separate filter, so everything
        // downstream keeps working off From / To alone.
        // ---------------------------------------------------------------------------------

        // The dashboard's own window opens on 01-April-2018, which is the start of FY 2018-19.
        // Earlier applications do exist and the Time Period filter reaches them, so the list
        // opens one year earlier than the page's stated start rather than hiding them.
        var FY_FIRST_YEAR = 2017;

        /** The year a financial year starts in - January to March still belong to the previous April. */
        function financialYearStartOf(date) {
            return date.getMonth() >= 3 ? date.getFullYear() : date.getFullYear() - 1;
        }

        function financialYearLabel(startYear) {
            var endYear = (startYear + 1) % 100;
            return 'FY ' + startYear + '-' + (endYear < 10 ? '0' + endYear : endYear);
        }

        vm.selectedFinancialYear = null;
        vm.financialYears = (function () {
            var years = [];
            for (var y = financialYearStartOf($scope.CurrentDate); y >= FY_FIRST_YEAR; y--) {
                years.push({ startYear: y, label: financialYearLabel(y) });
            }
            return years;
        })();

        vm.onFinancialYearChange = function () {
            var startYear = vm.selectedFinancialYear;
            if (startYear === null || startYear === undefined || startYear === '') {
                return;   // Custom - leave whatever the calendars are already showing
            }
            vm.filter.fromDate = new Date(startYear, 3, 1);        // 1 April
            var to = new Date(startYear + 1, 2, 31);               // 31 March
            // The current financial year has not finished yet, and neither picker allows a future
            // date, so the running year stops at today rather than at a March that has not come.
            if (to > $scope.CurrentDate) {
                to = new Date($scope.CurrentDate.getTime());
            }
            vm.filter.toDate = to;
            syncToDateBounds();
        };

        /**
         * What the Time Period column and the exports say. Describes the period that was actually
         * asked for, so a half open one reads as such instead of pretending to a bound it has not
         * got. Day precision, because the filter is by day.
         */
        function periodLabel(from, to, status) {
            if (!from && !to) {
                return DEFAULT_TIME_PERIOD;
            }
            var span;
            if (from && to) {
                span = $filter('date')(from, 'dd MMM yyyy') + ' - ' + $filter('date')(to, 'dd MMM yyyy');
            } else if (from) {
                span = $filter('date')(from, 'dd MMM yyyy') + ' onwards';
            } else {
                span = 'Up to ' + $filter('date')(to, 'dd MMM yyyy');
            }
            return span + ' (' + periodBasis(status) + ')';
        }

        /**
         * Which date the period was measured on. Worth spelling out on screen and in the exports,
         * because the same span of dates picks out different applications depending on it - a
         * form filed in March and cleared in June is inside one window and outside the other.
         */
        function periodBasis(status) {
            if (status === 'Approved') {
                return 'by cleared date';
            }
            if (status === 'Rejected') {
                return 'by rejection date';
            }
            return 'by form filled date';
        }

        loadAll();
        function loadAll() {
            Principal.identity().then(function(account) {
                vm.account = account;
            });

            District.query(function(result) {
                vm.districts = result;
            });

            vm.loading = true;
            EodbPublicDashboardByElastic.query(function(result) {
                vm.appliedDistrict = null;
                vm.appliedApplicationStatus = null;
                vm.timePeriod = DEFAULT_TIME_PERIOD;
                applyResult(result);
                vm.loading = false;
            }, function () {
                // Released on failure too, otherwise a single failed call leaves the filters
                // disabled for good with no way back.
                vm.loading = false;
            });
        }

        function applyResult(result) {
            vm.deptservicedashboard = result;
            vm.departments = [];
            angular.forEach(result, function(value){
                if (value.department_name
                    && vm.departments.indexOf(value.department_name) === -1
                    && value.department_name != "Communication and Connectivity Permissions") {
                    vm.departments.push(value.department_name);
                }
            });
            vm.departments.sort();
            vm.rebuildServiceList();
            vm.applyClientFilters();
        }

        /**
         * Services offered in the Service dropdown, narrowed to the chosen department so the list
         * stays usable. Clears the chosen service if it is no longer on offer.
         */
        vm.rebuildServiceList = function () {
            vm.services = [];
            angular.forEach(vm.deptservicedashboard, function(value){
                if (vm.clientFilter.departmentName && value.department_name !== vm.clientFilter.departmentName) {
                    return;
                }
                if (value.service_name && vm.services.indexOf(value.service_name) === -1) {
                    vm.services.push(value.service_name);
                }
            });
            vm.services.sort();
            if (vm.clientFilter.serviceName && vm.services.indexOf(vm.clientFilter.serviceName) === -1) {
                vm.clientFilter.serviceName = null;
            }
        };

        vm.onDepartmentChange = function () {
            vm.rebuildServiceList();
            vm.applyClientFilters();
        };

        // i. Department
        function matchesDepartment(row) {
            return !vm.clientFilter.departmentName || row.department_name === vm.clientFilter.departmentName;
        }

        // ii. Service
        function matchesService(row) {
            return !vm.clientFilter.serviceName || row.service_name === vm.clientFilter.serviceName;
        }

        // iv. SLA Status
        function matchesSlaStatus(row) {
            if (!vm.clientFilter.slaStatus) {
                return true;
            }
            var pct = parseFloat(row.slaMet);
            // "NA" rows have no measurable SLA, so they belong to neither Met nor Unmet.
            if (isNaN(pct)) {
                return false;
            }
            return vm.clientFilter.slaStatus === 'Met'
                ? pct >= SLA_MET_THRESHOLD
                : pct < SLA_MET_THRESHOLD;
        }

        function toNumber(value) {
            var parsed = parseInt(value, 10);
            return isNaN(parsed) ? 0 : parsed;
        }

        // v. Application Status - a row is kept when it has applications in the chosen status.
        function matchesApplicationStatus(row) {
            var status = vm.appliedApplicationStatus;
            if (!status) {
                return true;
            }
            if (status === 'Received') {
                return toNumber(row.applied) > 0;
            }
            if (status === 'Approved') {
                return toNumber(row.cleared) > 0;
            }
            if (status === 'Rejected') {
                return toNumber(row.rejected) > 0;
            }
            return true;
        }

        /**
         * Colour band for the SLA Met % cell: green at or above 90, yellow from 75 to 89, red
         * below 75. Services with no measurable SLA (rtsDays not configured, or no cleared
         * application carrying both dates) show as NA and stay grey rather than being coloured
         * red, which would read as a bad score rather than an absent one.
         */
        vm.slaIndicatorClass = function (row) {
            var pct = parseFloat(row.slaMet);
            if (isNaN(pct)) {
                return 'sla-na';
            }
            if (pct >= SLA_GREEN_FROM) {
                return 'sla-green';
            }
            if (pct >= SLA_YELLOW_FROM) {
                return 'sla-yellow';
            }
            return 'sla-red';
        };

        vm.applyClientFilters = function () {
            if (!vm.deptservicedashboard) {
                vm.visibleDashboard = [];
                return;
            }
            vm.visibleDashboard = vm.deptservicedashboard.filter(function (row) {
                return matchesDepartment(row)
                    && matchesService(row)
                    && matchesSlaStatus(row)
                    && matchesApplicationStatus(row);
            });
        };

        /**
         * Drops blank entries before the call. Selecting "All Districts" sets the model to "", and
         * the server side check is `getDistrict() != null` - an empty string passes that check and
         * would narrow the query to a district named "", i.e. nothing at all.
         */
        function cleanFilter(filter) {
            var cleaned = {};
            angular.forEach(filter, function (value, key) {
                if (value !== null && value !== undefined && value !== '') {
                    cleaned[key] = value;
                }
            });
            return cleaned;
        }

        // iii. District, Level and Time Period - the only round trip, because the server recomputes
        // every count for what was chosen instead of just hiding rows.
        vm.FilterWiseDat = function () {
            // Captured at request time, not read in the callback - the user is free to change the
            // controls again while the call is in flight, and the columns must describe the rows
            // that actually came back.
            var requested = cleanFilter(vm.filter);
            var requestedFrom = vm.filter.fromDate || null;
            var requestedTo = vm.filter.toDate || null;
            var requestedStatus = vm.filter.applicationStatus || null;

            // The server parses these as yyyy-MM-dd. Left as Date objects they would go out as
            // full ISO timestamps in the browser's zone, which for anywhere behind UTC lands on
            // the day before the one that was picked.
            if (requested.fromDate) {
                requested.fromDate = $filter('date')(requested.fromDate, 'yyyy-MM-dd');
            }
            if (requested.toDate) {
                requested.toDate = $filter('date')(requested.toDate, 'yyyy-MM-dd');
            }

            vm.loading = true;
            EodbPublicDashboardByFilter.query(requested, function (result) {
                vm.hideClear = true;
                vm.appliedDistrict = requested.district || null;
                vm.appliedApplicationStatus = requestedStatus;
                vm.timePeriod = periodLabel(requestedFrom, requestedTo, requestedStatus);
                applyResult(result);
                vm.loading = false;
            }, function () {
                vm.loading = false;
            })
        };

        vm.clearFilter = function () {
            vm.filter = {};
            vm.clientFilter = {};
            vm.selectedFinancialYear = null;
            vm.hideClear = false;
            vm.dateOptionsTo = { maxDate: $scope.CurrentDate };
            loadAll();
        };

        // ---------------------------------------------------------------------------------
        // Export. Both formats write exactly what is on screen - the rows left after the
        // filters, in the same column order - so a download always matches what was seen.
        // ---------------------------------------------------------------------------------

        var EXPORT_HEADERS = ['Service', 'Department', 'District', 'Time Period',
            'Applications Received', 'Applications Approved', 'Applications Rejected',
            'SLA Met (%)', 'Average Time (Days)', 'Fees Collected (INR)', 'Feedback Score (1-5)'];

        function exportRows() {
            return (vm.visibleDashboard || []).map(function (row) {
                return [
                    row.service_name || '',
                    row.department_name || '',
                    vm.appliedDistrict || 'All Districts',
                    vm.timePeriod,
                    row.applied || '0',
                    row.cleared || '0',
                    row.rejected || '0',
                    row.slaMet || 'NA',
                    row.avgTime || 'NA',
                    row.feesCollected || 'NA',
                    row.feedbackScore || 'NA'
                ];
            });
        }

        function exportFileName(extension) {
            return 'EODB-Public-Dashboard-' + $filter('date')(new Date(), 'yyyy-MM-dd-HHmm') + '.' + extension;
        }

        vm.canExport = function () {
            return !vm.loading && vm.visibleDashboard && vm.visibleDashboard.length > 0;
        };

        function saveBlob(blob, filename) {
            // Older IE / Edge cannot follow a blob: href on an anchor.
            if (window.navigator && window.navigator.msSaveBlob) {
                window.navigator.msSaveBlob(blob, filename);
                return;
            }
            var url = window.URL.createObjectURL(blob);
            var link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }

        // ---- xlsx writer -----------------------------------------------------------------
        // A .xlsx file is a ZIP of XML parts. There is no SheetJS or JSZip in this project, so
        // the few parts Excel needs are written here and stored (not deflated) into a ZIP, which
        // keeps this dependency free while still producing a genuine Excel workbook rather than a
        // CSV or an HTML table renamed .xls.

        function utf8Bytes(str) {
            var out = [], i, c, cp;
            for (i = 0; i < str.length; i++) {
                c = str.charCodeAt(i);
                if (c < 0x80) {
                    out.push(c);
                } else if (c < 0x800) {
                    out.push(0xC0 | (c >> 6), 0x80 | (c & 0x3F));
                } else if (c < 0xD800 || c >= 0xE000) {
                    out.push(0xE0 | (c >> 12), 0x80 | ((c >> 6) & 0x3F), 0x80 | (c & 0x3F));
                } else {
                    i++;
                    cp = 0x10000 + (((c & 0x3FF) << 10) | (str.charCodeAt(i) & 0x3FF));
                    out.push(0xF0 | (cp >> 18), 0x80 | ((cp >> 12) & 0x3F), 0x80 | ((cp >> 6) & 0x3F), 0x80 | (cp & 0x3F));
                }
            }
            return new Uint8Array(out);
        }

        var CRC_TABLE = null;
        function crc32(bytes) {
            if (!CRC_TABLE) {
                CRC_TABLE = [];
                for (var i = 0; i < 256; i++) {
                    var c = i;
                    for (var k = 0; k < 8; k++) {
                        c = (c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1);
                    }
                    CRC_TABLE[i] = c >>> 0;
                }
            }
            var crc = 0xFFFFFFFF;
            for (var n = 0; n < bytes.length; n++) {
                crc = (crc >>> 8) ^ CRC_TABLE[(crc ^ bytes[n]) & 0xFF];
            }
            return (crc ^ 0xFFFFFFFF) >>> 0;
        }

        function zipStore(files) {
            var now = new Date();
            var dosTime = (now.getHours() << 11) | (now.getMinutes() << 5) | (Math.floor(now.getSeconds() / 2));
            var dosDate = ((now.getFullYear() - 1980) << 9) | ((now.getMonth() + 1) << 5) | now.getDate();
            var parts = [], central = [], offset = 0;
            files.forEach(function (file) {
                var nameBytes = utf8Bytes(file.name), crc = crc32(file.data), size = file.data.length;
                var local = new Uint8Array(30 + nameBytes.length), dv = new DataView(local.buffer);
                dv.setUint32(0, 0x04034b50, true); dv.setUint16(4, 20, true); dv.setUint16(6, 0x0800, true);
                dv.setUint16(8, 0, true); dv.setUint16(10, dosTime, true); dv.setUint16(12, dosDate, true);
                dv.setUint32(14, crc, true); dv.setUint32(18, size, true); dv.setUint32(22, size, true);
                dv.setUint16(26, nameBytes.length, true); dv.setUint16(28, 0, true);
                local.set(nameBytes, 30);
                parts.push(local, file.data);

                var cd = new Uint8Array(46 + nameBytes.length), cv = new DataView(cd.buffer);
                cv.setUint32(0, 0x02014b50, true); cv.setUint16(4, 20, true); cv.setUint16(6, 20, true);
                cv.setUint16(8, 0x0800, true); cv.setUint16(10, 0, true); cv.setUint16(12, dosTime, true);
                cv.setUint16(14, dosDate, true); cv.setUint32(16, crc, true);
                cv.setUint32(20, size, true); cv.setUint32(24, size, true);
                cv.setUint16(28, nameBytes.length, true); cv.setUint16(30, 0, true); cv.setUint16(32, 0, true);
                cv.setUint16(34, 0, true); cv.setUint16(36, 0, true); cv.setUint32(38, 0, true);
                cv.setUint32(42, offset, true);
                cd.set(nameBytes, 46);
                central.push(cd);

                offset += local.length + size;
            });
            var centralSize = central.reduce(function (n, c) { return n + c.length; }, 0);
            var end = new Uint8Array(22), ev = new DataView(end.buffer);
            ev.setUint32(0, 0x06054b50, true); ev.setUint16(8, files.length, true);
            ev.setUint16(10, files.length, true); ev.setUint32(12, centralSize, true);
            ev.setUint32(16, offset, true); ev.setUint16(20, 0, true);
            return new Blob(parts.concat(central).concat([end]),
                { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        }

        function xmlEscape(value) {
            return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;').replace(/'/g, '&apos;');
        }

        function columnName(index) {
            var name = '';
            while (index > 0) {
                var rem = (index - 1) % 26;
                name = String.fromCharCode(65 + rem) + name;
                index = Math.floor((index - 1) / 26);
            }
            return name;
        }

        // Written as a real number so Excel can sort and total the column. "NA" stays text.
        function isNumericCell(value) {
            return value !== '' && value !== null && value !== undefined && /^-?\d+(\.\d+)?$/.test(String(value));
        }

        function buildSheetXml(headers, rows, slaColumnIndex) {
            var xml = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
                '<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">' +
                '<cols><col min="1" max="1" width="42"/><col min="2" max="2" width="34"/>' +
                '<col min="3" max="3" width="16"/><col min="4" max="4" width="20"/>' +
                '<col min="5" max="11" width="15"/></cols><sheetData>';
            xml += '<row r="1">';
            headers.forEach(function (header, i) {
                xml += '<c r="' + columnName(i + 1) + '1" t="inlineStr" s="1"><is><t>' + xmlEscape(header) + '</t></is></c>';
            });
            xml += '</row>';
            rows.forEach(function (row, r) {
                var rowNumber = r + 2;
                xml += '<row r="' + rowNumber + '">';
                row.forEach(function (cell, i) {
                    var ref = columnName(i + 1) + rowNumber, style = 0;
                    if (i === slaColumnIndex) {
                        var pct = parseFloat(cell);
                        if (!isNaN(pct)) {
                            style = pct >= SLA_GREEN_FROM ? 2 : (pct >= SLA_YELLOW_FROM ? 3 : 4);
                        }
                    }
                    var styleAttr = style ? ' s="' + style + '"' : '';
                    if (isNumericCell(cell)) {
                        xml += '<c r="' + ref + '"' + styleAttr + '><v>' + cell + '</v></c>';
                    } else {
                        xml += '<c r="' + ref + '" t="inlineStr"' + styleAttr + '><is><t>' + xmlEscape(cell) + '</t></is></c>';
                    }
                });
                xml += '</row>';
            });
            return xml + '</sheetData></worksheet>';
        }

        // Style 1 = header, 2/3/4 = the green / yellow / red SLA bands.
        var XLSX_STYLES = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
            '<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">' +
            '<fonts count="2"><font><sz val="11"/><name val="Calibri"/></font>' +
            '<font><b/><color rgb="FFFFFFFF"/><sz val="11"/><name val="Calibri"/></font></fonts>' +
            '<fills count="6"><fill><patternFill patternType="none"/></fill>' +
            '<fill><patternFill patternType="gray125"/></fill>' +
            '<fill><patternFill patternType="solid"><fgColor rgb="FF7B4CAF"/><bgColor indexed="64"/></patternFill></fill>' +
            '<fill><patternFill patternType="solid"><fgColor rgb="FFD4EDDA"/><bgColor indexed="64"/></patternFill></fill>' +
            '<fill><patternFill patternType="solid"><fgColor rgb="FFFFF3CD"/><bgColor indexed="64"/></patternFill></fill>' +
            '<fill><patternFill patternType="solid"><fgColor rgb="FFF8D7DA"/><bgColor indexed="64"/></patternFill></fill></fills>' +
            '<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>' +
            '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>' +
            '<cellXfs count="5">' +
            '<xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0"/>' +
            '<xf numFmtId="0" fontId="1" fillId="2" borderId="0" xfId="0" applyFont="1" applyFill="1"/>' +
            '<xf numFmtId="0" fontId="0" fillId="3" borderId="0" xfId="0" applyFill="1"/>' +
            '<xf numFmtId="0" fontId="0" fillId="4" borderId="0" xfId="0" applyFill="1"/>' +
            '<xf numFmtId="0" fontId="0" fillId="5" borderId="0" xfId="0" applyFill="1"/>' +
            '</cellXfs>' +
            '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>' +
            '</styleSheet>';

        /**
         * Downloads the rows currently on screen as a real .xlsx workbook.
         */
        vm.exportExcel = function () {
            if (!vm.canExport()) {
                return;
            }
            var sheetXml = buildSheetXml(EXPORT_HEADERS, exportRows(), 7);
            var files = [
                { name: '[Content_Types].xml', data: utf8Bytes('<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
                    '<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">' +
                    '<Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/>' +
                    '<Default Extension="xml" ContentType="application/xml"/>' +
                    '<Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/>' +
                    '<Override PartName="/xl/worksheets/sheet1.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>' +
                    '<Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/>' +
                    '</Types>') },
                { name: '_rels/.rels', data: utf8Bytes('<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
                    '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">' +
                    '<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/>' +
                    '</Relationships>') },
                { name: 'xl/workbook.xml', data: utf8Bytes('<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
                    '<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">' +
                    '<sheets><sheet name="EODB Dashboard" sheetId="1" r:id="rId1"/></sheets></workbook>') },
                { name: 'xl/_rels/workbook.xml.rels', data: utf8Bytes('<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
                    '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">' +
                    '<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet1.xml"/>' +
                    '<Relationship Id="rId2" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/>' +
                    '</Relationships>') },
                { name: 'xl/styles.xml', data: utf8Bytes(XLSX_STYLES) },
                { name: 'xl/worksheets/sheet1.xml', data: utf8Bytes(sheetXml) }
            ];
            saveBlob(zipStore(files), exportFileName('xlsx'));
        };

        /**
         * PDF via the jsPDF autoTable plugin already bundled in index.html. Landscape, because
         * eleven columns do not fit portrait, and the SLA cells keep their colour bands.
         */
        vm.exportPdf = function () {
            if (!vm.canExport()) {
                return;
            }
            var rows = exportRows();
            var margin = 24;
            var doc = new window.jspdf.jsPDF({ unit: 'pt', format: 'a4', orientation: 'landscape' });
            var pageWidth = doc.internal.pageSize.getWidth();

            doc.setFontSize(14);
            doc.setFont(undefined, 'bold');
            doc.text('EODB DASHBOARD', margin, margin + 6);

            doc.setFont(undefined, 'normal');
            doc.setFontSize(9);
            doc.text('Time Period: ' + vm.timePeriod
                + '   |   District: ' + (vm.appliedDistrict || 'All Districts')
                + '   |   Status: ' + (vm.appliedApplicationStatus || 'All')
                + '   |   Services: ' + rows.length,
                margin, margin + 22);
            doc.text('Generated on ' + $filter('date')(new Date(), 'dd/MM/yyyy HH:mm'),
                pageWidth - margin, margin + 22, { align: 'right' });

            doc.autoTable({
                startY: margin + 34,
                margin: { top: margin, right: margin, bottom: margin, left: margin },
                head: [EXPORT_HEADERS],
                body: rows,
                styles: { fontSize: 7, cellPadding: 3, overflow: 'linebreak', valign: 'middle' },
                headStyles: { fillColor: [123, 76, 175], textColor: 255, fontSize: 7 },
                columnStyles: {
                    0: { cellWidth: 118 },
                    1: { cellWidth: 92 },
                    3: { cellWidth: 68 }
                },
                // Carry the on screen SLA colour bands into the PDF.
                didParseCell: function (data) {
                    if (data.section !== 'body' || data.column.index !== 7) {
                        return;
                    }
                    var pct = parseFloat(data.cell.raw);
                    if (isNaN(pct)) {
                        return;
                    }
                    if (pct >= SLA_GREEN_FROM) {
                        data.cell.styles.fillColor = [212, 237, 218];
                    } else if (pct >= SLA_YELLOW_FROM) {
                        data.cell.styles.fillColor = [255, 243, 205];
                    } else {
                        data.cell.styles.fillColor = [248, 215, 218];
                    }
                }
            });

            var pageCount = doc.internal.getNumberOfPages();
            for (var page = 1; page <= pageCount; page++) {
                doc.setPage(page);
                doc.setFontSize(8);
                doc.text('Page ' + page + ' of ' + pageCount,
                    pageWidth - margin, doc.internal.pageSize.getHeight() - 12, { align: 'right' });
            }
            doc.save(exportFileName('pdf'));
        };

        vm.hasAnyFilter = function () {
            return !!(vm.filter.district || vm.filter.projectLevel
                || vm.filter.fromDate || vm.filter.toDate || vm.filter.applicationStatus
                || vm.clientFilter.departmentName || vm.clientFilter.serviceName
                || vm.clientFilter.slaStatus);
        };
    }
})();
